export const lineHeights = {
  heading: 1.25,
  body: 1.65,
}
